import React from "react";
import { ShieldOff, RefreshCw } from "lucide-react";
import AnimatedBackground from "units/client/component/AnimatedBackground";
import { useTranslation } from "react-i18next";

const WobListUnavailable = ({ onRetry, listErrorMessage }) => {
    const { t } = useTranslation(["user"]);

    return (
        <div className="min-h-screen flex items-center justify-center px-5 bg-transparent">
            <div className="w-full max-w-md bg-white dark:!bg-zinc-800 rounded-2xl border border-slate-200 dark:!border-zinc-700 shadow-lg p-8 text-center">

                <div className="mx-auto w-20 h-20 rounded-2xl bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center mb-5">
                    <ShieldOff
                        size={40}
                        className="text-amber-500 dark:text-amber-400"
                    />
                </div>

                <h2 className="text-xl font-bold text-zinc-800 dark:text-white mb-3">
                    {t("wobListUnavailable.title")}
                </h2>

                <div className="bg-amber-100 dark:!bg-slate-800 rounded-xl p-1 mt-2 ">
                    <p className="text-[13px] leading-7 text-red-600 ">
                        {listErrorMessage}
                    </p>
                </div>
                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="mt-6 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-amber-500 hover:bg-amber-600 text-white font-medium transition-all"
                    >
                        <RefreshCw size={17} />
                        {t("wobListUnavailable.retry")}
                    </button>
                )}
            </div>
        </div>
    );
};

export default WobListUnavailable;